import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import { useEpiserver } from '@episerver/spa-core';
import { getDescription } from '../../Utils';
import { LanguageTag } from 'app/Models/Constants/LanguageTypes';

interface MetaTagsProps {
    currentContent: any;
    currentLanguage?: string;
    norwegianCourtsLocaleText?: string;
}

export const MetaTags: React.FC<MetaTagsProps> = ({
    currentContent,
    currentLanguage = LanguageTag.NORWEGIAN,
    norwegianCourtsLocaleText = '',
}) => {
    const context = useEpiserver();

    const titleText =
        (currentContent?.heading?.value ? currentContent.heading.value : currentContent.name) +
        (norwegianCourtsLocaleText ? ' | ' + norwegianCourtsLocaleText : '');

    const metaTags = (
        <>
            <title>{titleText}</title>
            <meta
                property="og:title"
                content={currentContent?.heading?.value ? currentContent.heading.value : currentContent.name.toString()}
            />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content={currentLanguage} />
            <meta property="og:description" content={getDescription(currentContent)} />
            <meta name="description" content={getDescription(currentContent)} />
            <link rel="shortcut icon" href="/spaview/app.html.spa/favicon.svg" type="image/svg+xml" />
            <link rel="stylesheet" href="/StaticContent/oldDomstol/hoyesterett.min.css" />
            <style>
                {`
                .supremeCourt .external-link svg {
                    height: 16px !important;
                    width: 16px !important;
                }
                .supremeCourt .container {
                    width: inherit;
                }
                *::selection {
                    background-color: #ffe6df;
                    color: #0b0d0e;
                }
            `}
            </style>
        </>
    );

    if (context.isServerSideRendering()) {
        return <Helmet htmlAttributes={{ lang: currentLanguage }}>{metaTags}</Helmet>;
    }

    return <>{metaTags}</>;
};

export default MetaTags;
